import { ChangeEvent, FC, useCallback } from 'react';

import {
  Slider,
  SliderProps,
} from '@beeline/design-system-react/extracted-styles';

import { adminActions } from 'src/store/admin/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

import classes from './RotationField.module.scss';

export interface RotationFieldProps extends SliderProps {
  refreshId: number | undefined;
}

export const RotationField: FC<RotationFieldProps> = ({
  refreshId,
  ...rest
}) => {
  const dispatch = useAppDispatch();

  const changeRotation = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      dispatch(adminActions.update({ rotation: +e.target.value }));
    },
    [dispatch],
  );

  return (
    <Slider
      {...rest}
      key={refreshId}
      className={classes.rotation}
      onChange={changeRotation}
      showLabel
      showOptions
    />
  );
};
